import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const load = () => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <SettingsContext.Provider value={{ settings, reloadSettings: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
